
import React, { lazy } from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Imprint from './legal/Imprint';
import ScrollToTop from './components/ScrollToTop';
import { hasPaidAccess } from './services/authApi';

const Library = lazy(() => import('./pages/Library'));
const Pricing = lazy(() => import('./pages/Pricing'));
const Checkout = lazy(() => import('./pages/Checkout'));
const Unsubscribe = lazy(() => import('./pages/Unsubscribe'));
const MyAccount = lazy(() => import('./pages/MyAccount'));
const Login = lazy(() => import('./auth/Login'));
const Signup = lazy(() => import('./auth/Signup'));
const ForgotPassword = lazy(() => import('./auth/ForgotPassword'));
const TermsAndConditions = lazy(() => import('./legal/TermsAndConditions'));
const PrivacyPolicy = lazy(() => import('./legal/PrivacyPolicy'));
const NotFound = lazy(() => import('./pages/NotFound'));

function RequirePaidAccess({ children }: { children: React.ReactElement }) {
  return hasPaidAccess() ? children : <Navigate to="/pricing/" replace />;
}

function RequireAuth({ children }: { children: React.ReactElement }) {
  return localStorage.getItem('authToken') ? children : <Navigate to="/login/" replace />;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/library/" element={<RequirePaidAccess><Library /></RequirePaidAccess>} />
          <Route path="/pricing/" element={<Pricing />} />
          <Route path="/checkout/" element={<Checkout />} />
          <Route path="/unsubscribe/" element={<Unsubscribe />} />
          <Route path="/my-account/" element={<RequireAuth><MyAccount /></RequireAuth>} />
          <Route path="/profile/" element={<Navigate to="/login/" replace />} />
          <Route path="/login/" element={<Login />} />
          <Route path="/signup/" element={<Signup />} />
          <Route path="/forgot-password/" element={<ForgotPassword />} />
          <Route path="/terms-and-conditions/" element={<TermsAndConditions />} />
          <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
          <Route path="/imprint/" element={<Imprint />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
